import React from 'react';
import { useNavigate } from 'react-router-dom';
 
const Auth = () => {
  const navigate = useNavigate();

  return (
    <div className="auth-page">
      <div className="auth-container">
        <h2>المصادقة الثنائية</h2>
        <p>تم إرسال رمز التحقق إلى بريدك الإلكتروني</p>
        
        <div className="otp-inputs">
          <input type="text" maxLength="1" />
          <input type="text" maxLength="1" />
          <input type="text" maxLength="1" />
          <input type="text" maxLength="1" />
          <input type="text" maxLength="1" />
          <input type="text" maxLength="1" />
        </div>

        <button 
          className="btn btn-primary"
          onClick={() => navigate('/tests')}
        >
          تأكيد
        </button>

        <div className="auth-actions">
          <button className="resend-btn">
            إعادة إرسال الرمز
          </button>
          <button 
            className="back-btn"
            onClick={() => navigate('/login')}
          >
            العودة لتسجيل الدخول
          </button>
        </div>
      </div>
    </div>
  );
};

export default Auth;